export default "__VITE_ASSET__CpWVC_lG__"